export const moduleMenus = () => {
    const menusAnchorButtons = document.querySelectorAll('.js__menus__anchor');
    
	if (menusAnchorButtons) {
        menusAnchorButtons.forEach(btn => {
            const parentElem = btn.closest('.m__menus');

            btn.addEventListener('click',(event) => {
                event.preventDefault();
                
                const menuPDFs = parentElem.querySelector('.m__menus__pdfs');
                
                // Calculate the target offset from the top of the document
                let targetOffset = menuPDFs.getBoundingClientRect().top + window.scrollY;

                // Minus the height of the header from the offset
                targetOffset -= document.querySelector('.header').offsetHeight;
            
                // Smooth scroll animation
                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            });
        })
	}

    const yextTitle = document.querySelectorAll('.yext-menu-section-title');
    
    if (yextTitle.length > 0) {
        yextTitle.forEach(function(h1) {
            if (h1.textContent.includes('*')) {
                const span = document.createElement('span');
                span.classList.add('yext-menu-section-title');
                span.innerHTML = h1.innerHTML;
                h1.replaceWith(span);
            }
        });
    }
};